<template>
  <div class="search__tag">
    <span class="search__tag__title middle">{{ tab[0] }}：</span>
    <span class="search__tag__desc middle">{{ tab[1].displayCategoryName || tab[1] }}</span>
    <i class="el-icon-close search__tag__close middle" @click="$emit('close', tab)"></i>
  </div>
</template>

<script>
export default {
  props: {
    tab: {
      type: Array,
      default: () => {
        return ['标题', '内容'];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search__tag {
  height: 26px;
  padding: 6px 8px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  &::before {
    display: inline-block;
    content: '';
    height: 100%;
    vertical-align: middle;
  }
  &__title {
    color: #595959;
  }
  &__desc {
    color: #ff8300;
  }
  &__close {
    margin-left: 12px;
    color: #d9d9d9;
    &:hover {
      cursor: pointer;
    }
  }
  .middle {
    vertical-align: middle;
  }
  & + .search__tag {
    margin-left: 12px;
  }
}
</style>
